export function closestHTMLElement(target, selector) {
  if (!(target instanceof Element)) {
    return null;
  }

  const match = target.closest(selector);
  return match instanceof HTMLElement ? match : null;
}
